// extracted by mini-css-extract-plugin
export default {"root":"m2mEqYs2ZNKd8rjazCIr","th":"RSkfqfQrfZ3WrEhZp_ME","thContent":"niJbEELq6Kl_xRl34k0A","placeHolderShimmer":"QOTO3bv9GPVcaPKtfbh_"};